import React from "react";
import { ArrowRight, Check } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { BUSINESS, POSTERS } from "@/lib/business";

export default function AccidentProcess() {
  const { t } = useI18n();

  return (
    <section
      id="accident"
      data-testid="accident-section"
      className="relative py-16 md:py-20 overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(180deg, rgba(5,5,5,0.92), rgba(5,5,5,0.94)), url(${POSTERS.texture})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-12 max-w-2xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-10 h-px bg-[#e52620]" />
            <span
              data-testid="accident-eyebrow"
              className="text-[11px] uppercase tracking-[0.3em] text-zinc-400 font-bold font-mono"
            >
              {t.accident.eyebrow}
            </span>
          </div>
          <h2
            data-testid="accident-title"
            className="text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tighter text-white leading-[0.95] text-balance"
          >
            {t.accident.title}
          </h2>

          {/* Quick promises */}
          <ul className="mt-8 space-y-2.5">
            {t.accident.bullets.map((b, i) => (
              <li
                key={i}
                data-testid={`accident-bullet-${i}`}
                className="flex items-start gap-3 text-zinc-300"
              >
                <span className="mt-1 w-5 h-5 rounded-full bg-[#e52620]/20 border border-[#e52620]/40 flex items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 text-[#e52620]" strokeWidth={3} />
                </span>
                <span className="text-base md:text-lg">{b}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {t.accident.steps.map((s, i) => (
            <div
              key={i}
              data-testid={`accident-step-${i}`}
              className="relative group bg-[#0e0e0e] border border-white/10 rounded-xl p-8 hover:border-[#e52620]/40 transition-all duration-500"
            >
              <div className="text-[#e52620] font-black text-7xl tracking-tighter font-mono leading-none opacity-90 group-hover:opacity-100">
                {s.n}
              </div>
              <h3 className="mt-6 text-2xl font-bold text-white tracking-tight">
                {s.t}
              </h3>
              <p className="mt-3 text-zinc-400 leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex justify-start">
          <a
            data-testid="accident-cta"
            href={BUSINESS.whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 bg-[#e52620] hover:bg-[#c10015] text-white px-7 py-4 rounded-md font-bold uppercase tracking-[0.12em] text-sm transition-all active:scale-95 glow-red"
          >
            {t.accident.cta}
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
}
